import * as yup from "yup";

const addAndChangeSchemaProgram = (translate: Function) => yup.object().shape({
	pra001Titulo: yup.string().required(translate("Título é requerido")),
	pra001Efa005Id: yup.string().required(translate("Responsável é requerido")),
	pra001Efa005Id2: yup.string().required(translate("Autoridade é requerido")),
	pra001Kba001Id: yup.number().nullable(),
	prtba012: yup.array().of(yup.object().shape({
		pra012Id: yup.number(),
		pra012Tipo: yup.string(),
		pra012Efa005Id: yup.number().nullable(),
		pra012Efa004Id: yup.number().nullable()
	}))
		.unique(translate("Consultados não podem ser repetidos"), (a: any) => a.pra012Efa005Id, (a: any) => !a.pra012Efa004Id && a.pra012Tipo === "C")
		.unique(translate("Informados não podem ser repetidos"), (a: any) => a.pra012Efa005Id, (a: any) => !a.pra012Efa004Id && a.pra012Tipo === "I")
		.unique(translate("Consultados não podem ser repetidos"), (a: any) => a.pra012Efa004Id, (a: any) => !a.pra012Efa005Id && a.pra012Tipo === "C")
		.unique(translate("Informados não podem ser repetidos"), (a: any) => a.pra012Efa004Id, (a: any) => !a.pra012Efa005Id && a.pra012Tipo === "I")
});

const deleteSchemaProgram = (translate: Function) => yup.object().shape({
	pra001Titulo: yup.string().required(translate("Título do programa não confere")).oneOf([yup.ref("pra001TituloConfirmation")], translate("Título do programa não confere"))
});

export { addAndChangeSchemaProgram, deleteSchemaProgram };
